import React, { PropTypes, Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./actions";

import {
  NitroLoading,
  NitroDrawer,
  NitroContentNotAvailable,
  NitroButton
} from "nitro-components";

import { isEmpty, cloneDeep } from "lodash";

import ComponentFactory from "../../../components/utils/ComponentFactory.js";

import Breakpoint from "../../../utils/breakpoints";

class NotificationsSidePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFromNotification: true,
      mobileVersion: false,
      actionItems: {}
    };
    this.gerenateActionButtons = this.gerenateActionButtons.bind(this);
    this.callToAction = this.callToAction.bind(this);
  }

  componentDidMount() {
    if (!isEmpty(this.props.reportParam)) {
      this.props.actions.fetchNotificationDetail(this.props.reportParam);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { fetchSummaryDetails } = this.props.actions;
    const { navTitle } = nextProps;

    if (nextProps.navTitle !== this.props.navTitle) {
      this.setState({
        showFooterActions: false
      });
    }
    // fetch notiifcation details if report parameter exist and delete flag is updated

    //if (nextProps.navTitle === this.props.navTitle) return;

    nextProps.graphDetails &&
      nextProps.graphDetails.forEach(componenentDetails => {
        const { FetchParams } = componenentDetails;
        const DisplayType = componenentDetails["@DisplayType"];
        if (DisplayType === "remote")
          fetchSummaryDetails({ FetchParams, navTitle });
        if (DisplayType === "callToAction") {
          this.setState({
            showFooterActions: true
          });

          this.gerenateActionButtons(componenentDetails);
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.deleteGridItem !== this.props.deleteGridItem &&
      !this.props.deleteGridItemInProgress &&
      !isEmpty(this.props.reportParam)
    ) {
      this.props.actions.fetchNotificationDetail(this.props.reportParam);
    }

    if (
      !isEmpty(this.props.reportParam) &&
      this.props.reportParam !== prevProps.reportParam
    ) {
      console.log(this.props.reportParam);
      this.props.actions.fetchNotificationDetail(this.props.reportParam);
    }
  }

  arrayContains = (value, array) => {
    let found;
    for (let i = 0; i < array.length && !found; i++) {
      if (array[i] === value) {
        found = true;
        break;
      }
    }
    return found;
  };

  //Generate the action buttons in the side panel
  gerenateActionButtons = details => {
    // Object.assign({}, obj) ws causing stating mutation
    const componenentDetails = cloneDeep(details);
    let callToAction = componenentDetails.Component;
    const isMobile = this.props.isMobile;
    if (callToAction && callToAction.length > 0) {
      const obj = { left: [], right: [] };
      let doubleDashboards = false;

      const componentTypes = callToAction.map((item, index) => {
        return item.componentType;
      });

      if (
        this.arrayContains("driverProfile", componentTypes) &&
        this.arrayContains("vehicleProfile", componentTypes)
      ) {
        doubleDashboards = true;
      }
      callToAction.forEach(item => {
        item.action = () => this.callToAction(item);
        switch (item.componentType) {
          case "mobile":
            item.label = isMobile ? `Call` : `Call ${item.detail}`;

            obj.left.push(item);
            break;
          case "email":
            item.label = `Email`;
            obj.left.push(item);
            break;
          case "driverProfile":
            item.label = isMobile && !doubleDashboards
              ? `Profile `
              : "Driver Profile";
            item.variant = doubleDashboards ? "" : "secondary";
            doubleDashboards ? obj.left.push(item) : obj.right.push(item);
            break;
          case "vehicleProfile":
            item.label = isMobile && !doubleDashboards
              ? `Profile`
              : "Vehicle Profile";
            item.variant = "secondary";
            obj.right.push(item);
            break;
          default:
            return null;
        }
      });
      this.setState({ actionItems: obj });
    }
  };

  callToAction = item => {
    switch (item.componentType) {
      case "mobile":
        window.location = `tel:${item.detail.replace(/\s/g, "")}`;
        break;
      case "email":
        window.location = `mailto:${item.detail}`;
        break;
      case "driverProfile":
        this.context.router.push({
          pathname: item.detail.route,
          state: { id: item.detail.driverId, dashboardType: "driver" }
        });
        break;
      case "vehicleProfile":
        this.context.router.push({
          pathname: item.detail.route,
          state: { id: item.detail.leaseId, dashboardType: "vehicle" }
        });
        break;
      default:
    }
  };

  close = () => {
    this.setState({ showTable: "allCategoriesTable", actionItems: {} });
    this.props.close();
  };

  render() {
    const {
      drillDown,
      drillUp,
      fetchSummaryDetails,
      gridAction
    } = this.props.actions;
    const { isFromNotification } = this.state;
    const item = this.getFooterActionItems;
    // inject side panel hader with default graph title if server doesn't
    // provide navigation header
    const graphDetailsWithHeader =
      this.props.graphDetails &&
      (this.props.graphDetails.filter(
        d => d["@DisplayType"] === "navigation-header"
      ).length === 1
        ? this.props.graphDetails
        : [
            { "@DisplayType": "navigation-header", Title: this.props.title },
            ...this.props.graphDetails
          ]);

    const SidePanContents =
      this.props.graphDetails &&
      this.props.graphDetails.length > 0 &&
      graphDetailsWithHeader.map(
        (
          {
            Columns,
            Rows,
            Header,
            Title,
            Footers,
            Data,
            FetchParams,
            HeaderPostFix,
            ActionDetails,
            ...component
          },
          idx
        ) => {
          return (
            <ComponentFactory
              key={idx}
              {...{
                Columns,
                Rows,
                Header,
                Title,
                Footers,
                Data,
                drillUp,
                drillDown,
                isFromNotification,
                fetchSummaryDetails,
                title: this.props.title,
                navTitle: this.props.navTitle,
                FetchParams,
                HeaderPostFix,
                ActionDetails,
                gridAction,
                ...component
              }}
            />
          );
        }
      );

    return (
      <section>

        <NitroDrawer
          isOpen={this.props.open}
          close={this.close}
          width={450}
          padding="20px"
          actions={this.state.actionItems}
          labelVariant="secondary"
          staticFooter={
            this.state.actionItems && !isEmpty(this.state.actionItems)
              ? this.state.showFooterActions
              : false
          }
          iconVariant="white"
          closeIconSize={14}
        >

          {SidePanContents}
          {this.props.fetchingGraphDetail && <NitroLoading />}
          {(this.props.dataError ||
            (this.props.graphDetails && !this.props.graphDetails.length)) &&
            !this.props.fetchingGraphDetail &&
            <NitroContentNotAvailable />}

        </NitroDrawer>
      </section>
    );
  }
}

NotificationsSidePanel.propTypes = {
  title: PropTypes.string,
  navTitle: PropTypes.string,
  fetchGraphDetail: PropTypes.func,
  fetchSummaryDetails: PropTypes.func,
  actions: PropTypes.object,
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  graphDetails: PropTypes.array,
  reportParam: PropTypes.object,
  location: PropTypes.object,
  dataError: PropTypes.bool,
  fetchingGraphDetail: PropTypes.bool,
  isMobile: PropTypes.bool,
  deleteGridItem: PropTypes.bool,
  deleteGridItemInProgress: PropTypes.bool
};

NotificationsSidePanel.contextTypes = {
  router: PropTypes.object,
  location: PropTypes.object
};
const mapStateToProps = state => {
  return {
    graphDetails: state.globalNotification.GraphDetail,
    Description: state.globalNotification.Description,
    navTitle: state.globalNotification.navTitle,
    totalTillDate: state.globalNotification.totalTillDate,
    fetchingGraphDetail: state.globalNotification.fetchingGraphDetail,
    deleteGridItem: state.globalNotification.deleteGridItem,
    deleteGridItemInProgress: state.globalNotification.deleteGridItemInProgress
  };
};

/**const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});**/

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  NotificationsSidePanel
);



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/NotificationsSidePanel.js